
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_lx24u_153",
  "arrow-outer": "awsui_arrow-outer_xjuzf_lx24u_157",
  "arrow-inner": "awsui_arrow-inner_xjuzf_lx24u_157",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_lx24u_199",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_lx24u_199",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_lx24u_202",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_lx24u_202",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_lx24u_205",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_lx24u_205",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_lx24u_205",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_lx24u_205",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_lx24u_208",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_lx24u_208",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_lx24u_208",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_lx24u_208",
  "body": "awsui_body_xjuzf_lx24u_220",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_lx24u_256",
  "body-variant-chart": "awsui_body-variant-chart_xjuzf_lx24u_259",
  "has-dismiss": "awsui_has-dismiss_xjuzf_lx24u_264",
  "dismiss": "awsui_dismiss_xjuzf_lx24u_269",
  "dismiss-control": "awsui_dismiss-control_xjuzf_lx24u_277",
  "header-row": "awsui_header-row_xjuzf_lx24u_281",
  "header": "awsui_header_xjuzf_lx24u_281",
  "content": "awsui_content_xjuzf_lx24u_306",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_lx24u_314",
  "container": "awsui_container_xjuzf_lx24u_326",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_lx24u_337",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_lx24u_337",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_lx24u_337",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_lx24u_342",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_lx24u_342",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_lx24u_342",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_lx24u_347",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_lx24u_347",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_lx24u_352",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_lx24u_352",
  "container-body": "awsui_container-body_xjuzf_lx24u_358",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_lx24u_398",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_lx24u_403",
  "fixed-width": "awsui_fixed-width_xjuzf_lx24u_406",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_lx24u_410",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_lx24u_417",
  "container-arrow": "awsui_container-arrow_xjuzf_lx24u_337",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_lx24u_467",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_lx24u_1",
  "refresh": "awsui_refresh_xjuzf_lx24u_525",
  "root": "awsui_root_xjuzf_lx24u_547",
  "no-wrap": "awsui_no-wrap_xjuzf_lx24u_579",
  "root-filtering-token": "awsui_root-filtering-token_xjuzf_lx24u_583",
  "trigger": "awsui_trigger_xjuzf_lx24u_587",
  "overflow-ellipsis": "awsui_overflow-ellipsis_xjuzf_lx24u_594",
  "trigger-type-text-inline": "awsui_trigger-type-text-inline_xjuzf_lx24u_602",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_lx24u_602",
  "trigger-type-filtering-token": "awsui_trigger-type-filtering-token_xjuzf_lx24u_670",
  "popover-inline-content": "awsui_popover-inline-content_xjuzf_lx24u_674",
  "hover-area": "awsui_hover-area_xjuzf_lx24u_678"
};
  